import React, { useState } from 'react'
import logo from '../../assets/general/bluedoorLogo.svg'
import closeIcon from '../../assets/general/close-circle.svg'
import contactBg from '../../assets/general/contact-bg.png'
import mail from '../../assets/general/social/Icon-mail.svg'
import mobile from '../../assets/general/social/Icon-mobile.svg'
import location from '../../assets/general/social/Icon-Location.svg'

import emailjs from "emailjs-com";


const ContactForm = ({isContact, setIsContact}) => {

    const [name, setName] = useState('')
    const [email, setEmail] = useState('')
    const [company, setCompany] = useState('')
    const [mobile, setMobile] = useState('')
    const [message, setMessage] = useState('')

    const handleSubmit = () => {
        console.log('jjjjjjjjjj');
        
        emailjs
          .send(
            "service_bn1n6g5", // Replace with your EmailJS service ID
            "template_nhyhdka", // Replace with your EmailJS template ID
            {
              subject: "Callback request from website",
              title: "Details",
              name,
              email,
              company,
              mobile,
              message,
            },
            "J2B8qUjwsdx3_hELD"
          )
          .then(
            (response) => {
              alert("Email sent successfully!");
              setName("")
              setCompany("")
              setEmail("")
              setMessage("")
              setMobile("")
            },
            (error) => {
              alert("Failed to send email, please try again later.");
            }
          );
      };
    



  return (
    <div className={isContact ? 'fixed w-full md:w-[75vw] lg:w-[45vw] z-50 h-[100vh] md:!h-[80vh] overflow-y-scroll left-[0] md:left-[22vw] lg:left-[53vw] md:top-[15vh] lg:top-[20vh] flex flex-col md:rounded-xl duration-1000 transition-all ease-in-out' : 'fixed w-full md:w-[75vw] lg:w-[45vw] z-50 h-[100vh] md:!h-[80vh] overflow-y-scroll left-[103vw] md:top-[15vh] lg:top-[20vh] flex flex-col rounded-xl duration-1000 transition-all ease-in-out'}  >
      <div className='flex h-fit bg-cever gap-3 md:gap-6 bg-bottom px-4 md:px-6 py-8' style={{backgroundImage: `url(${contactBg})`, backgroundRepeat: 'no-repeat', backgroundSize: 'cover', backgroundPosition: 'right bottom'}} >
            <div className='flex flex-col justify-between w-full px-4  md:px-8'>
                <h1 className='text-2xl text-[#fff] font-mosk600 pb-2' >We'd love to know your ideas!</h1>
                <h3 className='text-[#fff] text-lg lg:text-xlfont-mosk600' >Talk to our experts</h3>
                <div className='flex flex-col gap-4' >
                    <input className='border-b-[1px] border-[#fff] bg-[#08023e] text-[#fff] focus:outline-none p-3' value={name} onChange={(e)=>{setName(e.target.value)}} placeholder='Full Name' type="text" />
                    <input className='border-b-[1px] border-[#fff] bg-[#08023e] text-[#fff] focus:outline-none p-3' value={company} onChange={(e)=>{setCompany(e.target.value)}}  placeholder='Company Name' type="text" />
                    <input className='border-b-[1px] border-[#fff] bg-[#08023e] text-[#fff] focus:outline-none p-3' value={mobile} onChange={(e)=>{setMobile(e.target.value)}}  placeholder='Mobile Number' type="text" />
                    <input className='border-b-[1px] border-[#fff] bg-[#08023e] text-[#fff] focus:outline-none p-3' value={email} onChange={(e)=>{setEmail(e.target.value)}}  placeholder='Email' type="text" />
                    <textarea className='min-h-[20vh] rounded-md p-3' placeholder='Describe your request and tell us about your ideas' value={message} onChange={(e)=>{setMessage(e.target.value)}}  id=""></textarea>
                    <button onClick={handleSubmit} className='py-3 px-6 my-3 bg-[#fff] w-fit rounded-full' >Request a call back</button>
                </div>
            </div>
            <div>
            <div className=' sticky top-5 flex items-start justify-center gap-4 pr-3' >
                <div className='hidden md:flex h-fit w-fit'>
                    <img  src={logo} alt="" />
                </div>
                <img className='w-[30px]' onClick={()=>setIsContact(false)}  src={closeIcon} alt="" />

                {/* <p className='text-[#fff] bg-[#000] h-[30px] text-3xl relative md:top-[-2vh] rounded-full cursor-pointer' >x</p> */}
            </div>

            </div>
      </div>
      <div className='bg-[#121028] relative top-[-5px] border-t-[2px] border-[#0095da] text-[#fff] py-8 px-6 flex flex-col items-center text-sm' >
        <div className='flex flex-col gap-3' >
            <div className='flex items-start gap-5'>
                <div className='flex gap-4 items-start' >
                    <img className='w-[20px]' src={mobile} alt="" />
                    <p>Mobile:</p>
                </div>
                <span className='flex gap-1' >
                    <p>9052224966</p>
                    <p>/</p>
                    <p>7207872864</p>
                </span>
            </div>
            <div className='flex items-start gap-8' >
                <div className='flex gap-4' >
                    <img className='w-[20px]' src={mail} alt="" />
                    <p>Email:</p>
                </div>
                <span className='flex flex-col' >
                    <p>admin@bluedoorevents.in</p>
                    <p>sapna@bluedoorevents.in</p>
                </span>
            </div>
            <div className='flex items-start gap-3' >
                <div className='flex gap-4 items-start' >
                    <img className='w-[20px]' src={location} alt="" />
                    <p>Address:</p>
                </div>
                <span>
                    <p>Blue Door Event Solutions</p>
                    <p>#101 Dhruv apartmetns, first floor</p>
                    <p>Street #10, Nehru Nagar, East Marredpally,</p>
                    <p>Secunderabad 500026</p>
                </span>
            </div>
        </div>   
      </div>
    </div>
  )
}

export default ContactForm
